<template>
    <div>
        <section class="m_video"><!-- ビデオ -->
            <div id="video-box" v-on:touchend="showContentsController" v-on:mousemove="showContentsController" v-on:mouseleave="hideContentsController">
                <div class="video-box" v-show="digicon_type=='music' && loadingStatus==false">
                    <img id="music01" :src="image" class="d-block mx-auto music-jacket" alt="" v-bind:class="{ 'fullscreen-jacket': fullscreenFlag }">
                    <div class="video-controller" v-show="!fullscreenFlag && (!playStatus || 0<controllerShowFlag)"><!-- コントローラ -->
                        <div class="seekbar-block"><!-- シークバー -->
                            <div v-on:click="seek" class="seekbar-ground" title="Time played : Total time">
                                <div :style="{ width: this.percentComplete + '%' }" class="seekbar-played"></div>
                            </div>
                        </div>
                        <div class="button-block"><!-- ボタン -->
                            <div class="left-block"><!-- 左側 -->
                                <div class="controller-button" v-if="playStatus === true"><img id="stop" src="/image/icons/player/stop.png" class="controller-icon" alt="stop" @click="stop"></div>
                                <div class="controller-button" v-if="playStatus === false"><img id="play" src="/image/icons/player/play.png" class="controller-icon" alt="play" @click="play"></div>
                                <!-- 再生ボタン/一時停止ボタン -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/back.png" alt="back" @click="back"></div>
                                <!-- 前へ -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/skip.png" alt="next" @click="forward"></div>
                                <!-- 次へ -->
                                <div class="time-block">
                                    <span class="time-controller">
                                        <span>{{ currentTime }}</span><!-- 再生時間 -->
                                        <span>/</span>
                                        <span>{{ durationTime }}</span><!-- 動画時間 -->
                                    </span>
                                </div>
                            </div>
                            <div class="right-block"><!-- 右側 -->
                                <div class="controller-button" v-if="shuffle_flag===false"><img src="/image/icons/player/shuffle_white.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <div class="controller-button" v-if="shuffle_flag===true"><img src="/image/icons/player/shuffle_blue.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <!-- シャッフルボタン -->
                                <div class="controller-button" v-if="repeat_flag===false"><img src="/image/icons/player/repeat_white.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <div class="controller-button" v-if="repeat_flag===true"><img src="/image/icons/player/repeat_blue.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <!-- リピートボタン -->
                                <div class="controller-button"><img src="/image/icons/player/fullscreen.png" alt="全画面" class="controller-icon" @click="requestFullScreen" v-if="!fullscreenFlag"></div>
                                <!-- 全画面ボタン -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="video-box" v-show="digicon_type=='video' && loadingStatus==false">
                    <video id="video01" class="video-js vjs-default-skin vjs-16-9" data-setup="{}" playsinline />
                    <div class="video-controller" v-show="!fullscreenFlag && (!playStatus || 0<controllerShowFlag)"><!-- コントローラ -->
                        <div class="seekbar-block"><!-- シークバー -->
                            <div v-on:click="seek" class="seekbar-ground" title="Time played : Total time">
                                <div :style="{ width: this.percentComplete + '%' }" class="seekbar-played"></div>
                            </div>
                        </div>
                        <div class="button-block"><!-- ボタン -->
                            <div class="left-block"><!-- 左側 -->
                                <div class="controller-button" v-if="playStatus === true"><img id="stop" src="/image/icons/player/stop.png" class="controller-icon" alt="stop" @click="stop"></div>
                                <div class="controller-button" v-if="playStatus === false"><img id="play" src="/image/icons/player/play.png" class="controller-icon" alt="play" @click="play"></div>
                                <!-- 再生ボタン/一時停止ボタン -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/back.png" alt="back" @click="back"></div>
                                <!-- 前へ -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/skip.png" alt="next" @click="forward"></div>
                                <!-- 次へ -->
                                <div class="time-block">
                                    <span class="time-controller">
                                        <span>{{ currentTime }}</span><!-- 再生時間 -->
                                        <span>/</span>
                                        <span>{{ durationTime }}</span><!-- 動画時間 -->
                                    </span>
                                </div>
                            </div>
                            <div class="right-block"><!-- 右側 -->
                                <div class="controller-button" v-if="shuffle_flag===false"><img src="/image/icons/player/shuffle_white.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <div class="controller-button" v-if="shuffle_flag===true"><img src="/image/icons/player/shuffle_blue.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <!-- シャッフルボタン -->
                                <div class="controller-button" v-if="repeat_flag===false"><img src="/image/icons/player/repeat_white.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <div class="controller-button" v-if="repeat_flag===true"><img src="/image/icons/player/repeat_blue.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <!-- リピートボタン -->
                                <div class="controller-button"><img src="/image/icons/player/fullscreen.png" alt="全画面" class="controller-icon" @click="requestFullScreen" v-if="!fullscreenFlag"></div>
                                <!-- 全画面ボタン -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="video-box loading-container" v-show="loadingStatus==true">
                    <div class="loading-bar">
                        <vue-loading type="spiningDubbles" color="#aaa" :size="{ width: '100px', height: '100px' }"></vue-loading>
                    </div>
                </div>
                <!-- 全画面表示時のコントローラ(ｺｺｶﾗ) -->
                <div v-if="fullscreenFlag && (!playStatus || 0<controllerShowFlag)" class="fullscreen-controller">
                    <div class="fullscreen-top">
                        <div class="fullscreen-title">
                            <div class="fullscreen-content-title">{{ content_title }}</div>
                            <div class="fullscreen-album-title">{{ item_title }}</div>
                        </div>
                    </div>
                    <div class="fullscreen-video-controller"><!-- コントローラ -->
                        <div class="seekbar-block"><!-- シークバー -->
                            <div v-on:click="seek" class="seekbar-ground" title="Time played : Total time">
                                <div :style="{ width: this.percentComplete + '%' }" class="seekbar-played"></div>
                            </div>
                        </div>
                        <div class="button-block"><!-- ボタン -->
                            <div class="left-block"><!-- 左側 -->
                                <div class="controller-button" v-if="playStatus === true"><img id="stop" src="/image/icons/player/stop.png" class="controller-icon" alt="stop" @click="stop"></div>
                                <div class="controller-button" v-if="playStatus === false"><img id="play" src="/image/icons/player/play.png" class="controller-icon" alt="play" @click="play"></div>
                                <!-- 再生ボタン/一時停止ボタン -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/back.png" alt="back" @click="back"></div>
                                <!-- 前へ -->
                                <div class="controller-button"><img class="controller-icon" src="/image/icons/player/skip.png" alt="next" @click="forward"></div>
                                <!-- 次へ -->
                                <div class="time-block">
                                    <span class="time-controller">
                                        <span>{{ currentTime }}</span><!-- 再生時間 -->
                                        <span>/</span>
                                        <span>{{ durationTime }}</span><!-- 動画時間 -->
                                    </span>
                                </div>
                            </div>
                            <div class="right-block"><!-- 右側 -->
                                <div class="controller-button" v-if="shuffle_flag===false"><img src="/image/icons/player/shuffle_white.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <div class="controller-button" v-if="shuffle_flag===true"><img src="/image/icons/player/shuffle_blue.png" class="controller-icon" alt="shuffle" v-if="type=='content' || type=='playlist'" @click="shuffle"></div>
                                <!-- シャッフルボタン -->
                                <div class="controller-button" v-if="repeat_flag===false"><img src="/image/icons/player/repeat_white.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <div class="controller-button" v-if="repeat_flag===true"><img src="/image/icons/player/repeat_blue.png" class="controller-icon" alt="repeat" v-if="type=='content' || type=='playlist'" @click="repeat"></div>
                                <!-- リピートボタン -->
                                <div class="controller-button"><img src="/image/icons/player/fullscreen_exit.png" alt="全画面終了" class="controller-icon" @click="exitFullScreen" v-if="fullscreenFlag"></div>
                                <!-- 全画面ボタン -->
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 全画面表示時のコントローラ(ｺｺﾏﾃﾞ) -->
            </div>
        </section>

        <section class="m_info"><!-- 音楽情報 -->
            <div class="m_tit">{{ content_title }}</div>
            <div class="a_tit">{{ item_title }}</div>
            <div class="m_button" v-if="type=='content'">
                <button class="btn btn-outline-dark ml-auto" v-if="0<contents.length && contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)">{{ characters.add_favorite_content }}</button>
                <button class="btn btn-outline-dark ml-auto" v-if="0<contents.length && contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)">{{ characters.remove_favorite_content }}</button>
            </div>
            <div></div>
       </section>

        <section v-if="type=='content' || type=='playlist'">
            <div class="pl_box">
                <div class="pl_container" v-show="open_flag">
                    <div class="pl_item_box_par" v-for="(content, index) in contents">
                        <div class="pl_item_box">
                            <div class="pl_item screen-transition" @click="jump(content.digicon_id)">{{ content.title }}</div>
                            <button class="btn btn-outline-dark ml-auto" v-if="type=='content' && content.favorite_status==0" @click="addFavoriteList(index)">{{ characters.add_favorite_content }}</button>
                            <button class="btn btn-outline-dark ml-auto" v-if="type=='content' && content.favorite_status==1" @click="removeFavoriteList(index)">{{ characters.remove_favorite_content }}</button>
                            <!-- <button class="btn btn-outline-dark ml-auto" v-if="type=='content'" @click="select(content.digicon_id, $event)">{{ characters.add_music_to_playlist }}</button> -->
                        </div>
                    </div>
                </div>
                <div class="pl_switch">
                    <button class="pl_button" @click="changeOpenFlag">{{ open_flag?characters.close_playlist:characters.open_playlist }}</button>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    import { VueLoading } from 'vue-loading-template';
    export default {
        name: "digicon-player",
        components: {
            VueLoading,
        },
        props: {
            item_id: {
                type: String,
                default: '0',
            },
            playlist_id: {
                type: String,
                default: '0',
            },
            digicon_id: {
                type: String,
            },
            json_characters: {
                type: String,
            },
            pre_shuffle_flag: {
                type: String,
                default: '0',
            },
            type: {
                type: String,
            }},
        data: function () {
            return {
                audio: new Audio,
                video: undefined,
                playStatus: false,
                currentSeconds: 0,
                durationSeconds: 0,
                content_title: '',
                item_title: '',
                contents: [],
                image: undefined,
                playing_number: Number,
                repeat_flag: false,
                shuffle_flag: false,
                origin_contents: [],
                characters: Object,
                digicon_type: String,
                open_flag: false,
                fullscreenFlag: false,
                controllerShowFlag: 0,
                showControllerTimerId: null,
                supportTouch: undefined,
                videoFullscreenFlag: false,
                getAlbumInfoPath: '',
                getContentInfoPath: '',
                loadingStatus: false,
                playStartSec: 0,
                recordedFlag: false,
                finFlag: false,
                show_method_exec_status: false,
                sample_flag: 0,
            }
        },
        mounted() {
            this.supportTouch = 'ontouchend' in document;
            document.addEventListener('fullscreenchange', this.fullscreenListener, false);
            document.addEventListener('webkitfullscreenchange', this.fullscreenListener, false);
            document.addEventListener('mozfullscreenchange', this.fullscreenListener, false);
            document.addEventListener('MSFullscreenChange', this.fullscreenListener, false);
            this.getAlbumInfoPath = (this.type=='sample' || this.type=='content')?'/digicon/detail/'+this.item_id:(this.type=='playlist')?'/playlist/detail/'+this.playlist_id:'';
            this.getAlbumInfoPath = (this.type=='content')?'/purchased'+this.getAlbumInfoPath:this.getAlbumInfoPath;
            this.getContentInfoPath = (this.type=='sample')?'/digicon/sample/':(this.type=='content' || this.type=='playlist')?'/digicon/content/':'';
            axios.default
                .post(this.getAlbumInfoPath, {type: this.type})
                .then(response => {
                    this.origin_contents = response.data;
                    this.contents = this.origin_contents.slice(0, this.origin_contents.length);
                    this.jump(this.digicon_id);
                    if(this.pre_shuffle_flag == '1') {
                        this.shuffle();
                    }
                });
            this.video = videojs("video01", {html5: {
                }},
                );
            this.characters = JSON.parse(this.json_characters);
            this.setAudioConfig();
            this.setVideoConfig();
            this.sample_flag = this.sample_flag?1:0;
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number, this.contents[this.playing_number].type);
                    return;
                }
                if(this.digicon_type=='music') {
                    this.audio.play();
                } else if(this.digicon_type=='video') {
                    this.video.play();
                }
                this.resetPlayingSec();
                // this.showContentsController();
            },
            stop: function() {
                if(this.digicon_type=='music') {
                    this.audio.pause();
                } else if(this.digicon_type=='video') {
                    this.video.pause();
                }
            },
            convertTimeHHMMSS: function(val) {
	            let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
	            return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
            },
            seek: function(e) {
                if (!this.playStatus || e.target.tagName === 'SPAN') {
                    return;
                }

                const el = e.target.getBoundingClientRect();
                const seekPos = (e.clientX - el.left) / el.width;
                if(this.digicon_type=='music') {
                    this.audio.currentTime = parseInt(this.audio.duration * seekPos);
                } else if(this.digicon_type=='video') {
                    this.video.currentTime(parseInt(this.video.duration() * seekPos));
                }
                this.resetPlayingSec();
                this.recordedFlag = false;
            },
            setAudioConfig: function() {
                this.audio.addEventListener('loadstart', function(e) {
                    this.loadingStatus = true;
                }.bind(this));
                this.audio.addEventListener('loadedmetadata', function(e) {
                    this.durationSeconds = parseInt(this.audio.duration);
                    this.currentSeconds = 0;
                    this.loadingStatus = false;
                    this.play();
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                }.bind(this));
                this.audio.addEventListener('timeupdate', function(e) {
                    this.currentSeconds = parseInt(this.audio.currentTime);
                    this.recordPlayLog();
                }.bind(this));
                this.audio.addEventListener('play', function(e) {
                    this.playStatus = true;
                }.bind(this));
                this.audio.addEventListener('pause', function(e) {
                    this.playStatus = false;
                }.bind(this));
                this.audio.addEventListener('ended', function(e) {
                    this.forward();
                }.bind(this));
            },
            setVideoConfig: function() {
                this.video.on('loadstart', function() {
                    this.loadingStatus = true;
                }.bind(this));
                this.video.on('loadedmetadata', function() {
                    this.durationSeconds = (Number.isNaN(this.video.duration()))?0:parseInt(this.video.duration());
                    this.currentSeconds = 0;
                    this.loadingStatus = false;
                    this.play();
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.currentSeconds = parseInt(this.video.currentTime());
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('play', function() {
                    if(this.durationSeconds == 0 && !Number.isNaN(this.video.duration())) {
                        this.durationSeconds = parseInt(this.video.duration());
                    }
                    this.playStatus = true;
                }.bind(this));
                this.video.on('pause', function() {
                    this.playStatus = false;
                }.bind(this));
                this.video.on('ended', function() {
                    this.currentSeconds = this.durationSeconds;
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path, type) {
                if(type=='music') {
                    if(this.videoFullscreenFlag==true) {
                        this.exitFullScreen();
                    }
                    this.audio.src = path;
                } else if(type=='video') {
                    this.video.src(path);
                }
            },
            setDigicon: function(playing_number) {
                this.content_title = (this.type=='sample')?this.contents[playing_number].title+'('+this.characters.trial_version+')':this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                this.image = '/item/image/'+this.contents[playing_number].item_id
                this.digicon_type = this.contents[playing_number].type;
                axios.default
                    .get(this.getContentInfoPath+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path, this.digicon_type);
                    });
            },
            forward: function() {
                this.stop();
                if(this.repeat_flag !== true) {
                    if(this.contents.length-1 <= this.playing_number) {
                        this.finFlag = true;
                        return;
                    } else {
                        this.playing_number++;
                    }
                }
                this.setDigicon(this.playing_number, this.contents[this.playing_number].type);
            },
            back: function() {
                this.stop();
                if(this.repeat_flag !== true) {
                    if(this.playing_number <= 0) {
                        this.playing_number = this.contents.length-1;
                    } else {
                        this.playing_number--;
                    }
                }
                this.setDigicon(this.playing_number, this.contents[this.playing_number].type);
            },
            repeat: function() {
                this.repeat_flag = (this.repeat_flag)?false:true;
            },
            shuffle: function() {
                if(this.shuffle_flag===false) {
                    this.shufflePlaylistOrder();
                }
                if(this.shuffle_flag===true) {
                    let digicon_id = this.contents[this.playing_number].digicon_id;
                    this.setOriginalOrder(digicon_id);
                }
                this.shuffle_flag = (this.shuffle_flag)?false:true;
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    if(content.digicon_id == digicon_id) {
                        this.playing_number = index;
                        this.setDigicon(this.playing_number, this.contents[this.playing_number].type);
                        break;
                    }
                    index++;
                }
            },
            shufflePlaylistOrder: function() {
                let playlist = this.contents;
                let playing_number = this.playing_number;
                for(let i = playlist.length - 1; i > 0; i--){
                    let r = Math.floor(Math.random() * (i + 1));
                    let tmp = playlist[i];
                    playlist[i] = playlist[r];
                    playlist[r] = tmp;
                    if(i == playing_number) {
                        playing_number = r;
                    }
                    if(r == playing_number) {
                        playing_number = i;
                    }
                }
                this.contents = playlist;
                this.playing_number = playing_number;
            },
            setOriginalOrder: function(digicon_id) {
                let origin_contents = this.origin_contents.slice(0, this.origin_contents.length);;
                let index = 0;
                for(let music of origin_contents) {
                    if(music.digicon_id == digicon_id) {
                        this.playing_number = index;
                        break;
                    }
                    index++;
                }
                this.contents = origin_contents;
            },
            changeOpenFlag: function() {
                this.open_flag = this.open_flag?false:true;
            },
            requestFullScreen: function() {
                let target = document.getElementById('video-box');
                if (target.webkitRequestFullscreen) {
                    target.webkitRequestFullscreen(); //Chrome15+, Safari5.1+, Opera15+
                } else if (target.mozRequestFullScreen) {
                    target.mozRequestFullScreen(); //FF10+
                } else if (target.msRequestFullscreen) {
                    target.msRequestFullscreen(); //IE11+
                } else if (target.requestFullscreen) {
                    target.requestFullscreen(); // HTML5 Fullscreen API仕様
                } else if(this.digicon_type == 'video'){
                    this.video.requestFullscreen();
                    this.videoFullscreenFlag = true;
                    return;
                }
            },
            exitFullScreen: function() {
                if (document.webkitCancelFullscreen) {
                    document.webkitCancelFullscreen(); //Chrome15+, Safari5.1+, Opera15+
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen(); //FF10+
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen(); //IE11+
                } else if (document.cancelFullscreen) {
                    document.cancelFullscreen(); // Gecko Fullscreen API仕様
                } else if (document.exitFullscreen) {
                    document.exitFullscreen(); // HTML5 Fullscreen API仕様
                } else {
                    this.video.exitFullscreen();
                    this.videoFullscreenFlag = false;
                    return;
                }
            },
            fullscreenListener: function() {
                if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
                    this.fullscreenFlag = true;
                    this.lockOrientation("landscape");
                    // document.addEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showContentsController, false);
                } else {
                    this.fullscreenFlag = false;
                    this.unlockOrientation();
                    // document.removeEventListener(this.supportTouch ? 'touchend' : 'mousemove', this.showContentsController, false);
                }
            },
            lockOrientation: function(mode) {
                if (screen.webkitLockOrientation) {
                    screen.webkitLockOrientation(mode);
                }
                else if (screen.mozLockOrientation) {
                    screen.mozLockOrientation(mode);
                }
                else if (screen.msLockOrientation) {
                    screen.msLockOrientation(mode);
                }
                else if (screen.lockOrientation) {
                    screen.lockOrientation(mode);
                }
                else if (screen.orientation.lock) {
                    screen.orientation.lock(mode);
                } else {
                    return;
                }
            },
            unlockOrientation: function() {
                if (screen.webkitUnlockOrientation) {
                    screen.webkitUnlockOrientation();
                }
                else if (screen.mozUnlockOrientation) {
                    screen.mozUnlockOrientation();
                }
                else if (screen.msUnlockOrientation) {
                    screen.msUnlockOrientation();
                }
                else if (screen.unlockOrientation) {
                    screen.unlockOrientation();
                }
                else if (screen.orientation.unlock) {
                    screen.orientation.unlock();
                } else {
                    return;
                }
            },
            showContentsController: function() {
                if(this.show_method_exec_status) {
                    return;
                }
                this.show_method_exec_status = true;
                this.controllerShowFlag = 1;
                if(this.showControllerTimerId) {
                    clearTimeout(this.showControllerTimerId);
                }
                this.showControllerTimerId = setTimeout(function() {
                    this.controllerShowFlag = 0;
                    this.showControllerTimerId = null;
                }.bind(this), 4000);
                this.show_method_exec_status = false;
            },
            hideContentsController: function() {
                if(this.showControllerTimerId) {
                    this.controllerShowFlag = 0;
                    clearTimeout(this.showControllerTimerId);
                    this.showControllerTimerId = null;
                }
            },
            select: function (s, event) {
                if (s) {
                    const id = Number(s);
                    location.href = `/playlist/add/${id}`;
                }
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(this.type=='sample') return;
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            console.log('error: '+res.error_message);
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            console.log('error: '+res.error_message);
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
        },
        computed: {
		    currentTime() {
                return this.convertTimeHHMMSS(this.currentSeconds);
            },
            durationTime() {
                return this.convertTimeHHMMSS(this.durationSeconds);
            },
            percentComplete() {
                return parseInt(this.currentSeconds / this.durationSeconds * 100);
            },
            muted() {
                return this.volume / 100 === 0;
            }
        },
    }
</script>

<style scoped>
</style>
